// A photo still in the outbox, rendered from its own bytes. Object URLs are
// collected into `urls` so the caller can revoke them on unmount.
//
// v0.171.0 — written for the plan's pin card (PlanScreen).
// v0.255.0 — a listed row carries no bytes (71 queued photos read at once is
// what made iOS close the app). This row's own copies are read here, and only
// the small ones: the thumbnail, and the display copy for the full view (the
// original only when a photo has no display copy).
// v0.261.0 — moved here from PlanScreen so the register's photo sheet shows
// the same queued photos the pin card does.
import { getRowBlobs, isStoredBytes } from './outbox.js';
import { localIdFor } from './outbox-local.js';

export async function queuedPhotoView(row, urls) {
  let blobs = {};
  try {
    blobs = (await getRowBlobs(row.id, ['thumbnailUrl', 'displayUrl'])) || {};
    if (!blobs.displayUrl) blobs = { ...blobs, ...((await getRowBlobs(row.id, ['url'])) || {}) };
  } catch (_e) { /* not readable now: the body's own URLs, or nothing */ }
  const body  = row.body && typeof row.body === 'object' ? row.body : {};
  // v0.174.0 — bytes are stored as { bytes, type } now (a Blob in IndexedDB
  // does not survive an iOS restart); a pre-v0.174 row still holds a Blob.
  // Either way the preview is an object URL over real bytes.
  const obj = (stored) => {
    if (!stored) return null;
    try {
      const blob = isStoredBytes(stored)
        ? new Blob([stored.bytes], { type: stored.type || 'image/jpeg' })
        : stored;
      const u = URL.createObjectURL(blob);
      urls.push(u);
      return u;
    } catch (_e) { return null; }
  };
  const url   = obj(blobs.displayUrl) || obj(blobs.url) || (typeof body.url === 'string' ? body.url : null);
  const thumb = obj(blobs.thumbnailUrl) || (typeof body.thumbnailUrl === 'string' ? body.thumbnailUrl : null);
  return {
    id: localIdFor(row.id),
    url,
    thumbnailUrl: thumb || url,
    caption: body.caption || null,
    name: body.caption || null,
    pending: true,
  };
}
